import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const API_FUNCTIONS_URL =
  process.env.REACT_APP_FUNCTIONS_URL ||
  "https://us-central1-multirent-918e4.cloudfunctions.net";

const authService = {
  register: async (userData) => {
    try {
      const response = await axios.post(`${API_FUNCTIONS_URL}/registerUser`, {
        tipoUsuario: userData.tipoUsuario,
        firtsname: userData.firtsname,
        lastname: userData.lastname,
        razonSocial: userData.razonSocial,
        cuit: userData.cuit,
        phone: userData.phone,
        whatsapp: userData.whatsapp,
        documento_tipo: userData.documento_tipo,
        documento_numero: userData.documento_numero,
        name:
          userData.tipoUsuario === "empresa"
            ? userData.razonSocial
            : `${userData.firtsname} ${userData.lastname}`,
        email: userData.email,
        password: userData.password,
        location: userData.location || "",
        lat: userData.lat,
        lng: userData.lng,
        addressComponents: userData.addressComponents || {},
        responsable: userData.responsable,
        recaptchaToken: userData.recaptchaToken,
      });
      return response.data;
    } catch (error) {
      console.error("Error en registro:", error);
      if (error.response?.data?.error?.message) {
        throw new Error(error.response.data.error.message);
      }
      throw new Error("Error al registrar usuario");
    }
  },

  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      console.error("Error en login:", error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Error al iniciar sesión");
    }
  },

  resetPassword: async (email) => {
    try {
      const response = await axios.post(`${API_URL}/auth/reset-password`, {
        email,
      });

      return response.data;
    } catch (error) {
      console.error("Error al resetear contraseña:", error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Error al resetear contraseña");
    }
  },

  registerWithGoogle: async (userData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/registerWithGoogle`,
        userData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message || "Error con Google"
      );
    }
  },

  loginWithGoogle: async (userData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/loginWithGoogle`,
        userData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message || "Error con Google"
      );
    }
  },

  // Nueva función para verificar el estado de verificación de email
  checkEmailVerification: async (uid) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/checkEmailVerification`,
        { uid }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message || "Error al verificar email"
      );
    }
  },

  // Nueva función para reenviar email de verificación
  resendVerificationEmail: async (email) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/resendVerificationEmail`,
        { email }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message || "Error al reenviar email"
      );
    }
  },

  // Función para enviar email de bienvenida tras verificación
  sendWelcomeEmail: async (userEmail, userName, uid) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/sendWelcomeEmail`,
        { userEmail, userName, uid }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message ||
          "Error al enviar email de bienvenida"
      );
    }
  },

  // Función para notificar al propietario sobre nuevo alquiler
  notifyOwnerNewRental: async (rentalData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/notifyOwnerNewRental`,
        rentalData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message || "Error al enviar notificación"
      );
    }
  },

  // Función para notificar sobre nueva disputa
  notifyDispute: async (disputeData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/notifyDispute`,
        disputeData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message ||
          "Error al enviar notificación de disputa"
      );
    }
  },

  // Función para notificar cancelación de alquiler
  notifyRentalCancellation: async (cancellationData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/notifyRentalCancellation`,
        cancellationData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message ||
          "Error al enviar notificación de cancelación"
      );
    }
  },

  // Función para notificar al administrador sobre reserva sin pago
  notifyAdminReservationWithoutPayment: async (reservationData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/notifyAdminReservationWithoutPayment`,
        reservationData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message ||
          "Error al enviar notificación de reserva sin pago"
      );
    }
  },

  // Función para enviar email personalizado
  sendCustomEmail: async (emailData) => {
    try {
      const response = await axios.post(
        `${API_FUNCTIONS_URL}/sendCustomEmail`,
        emailData
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error?.message ||
          "Error al enviar email personalizado"
      );
    }
  },
};

export default authService;
